import React from "react";

interface ISkeletonLoaderProps {
    type: "image" | "text";
}

const SkeletonLoader: React.FC<ISkeletonLoaderProps> = ({ type }) => {
    return (
        <div className={`immersion__skeleton_loader ${type === "image" ? "image-loader" : "text-loader"}`}>
            {type === "image" && (
                <div className="immersion__skeleton_loader__content">
                    <div className="immersion__skeleton_loader__content__image skeleton-shimmer"></div>
                    <div className="immersion__skeleton_loader__content__text skeleton-shimmer"></div>
                </div>
            )}
            {type === "text" && (
                <div className="immersion__skeleton_loader__content">
                    <div className="immersion__skeleton_loader__content__text skeleton-shimmer"></div>
                </div>
            )}
        </div>
    );
};

export default SkeletonLoader;
